import { render, staticRenderFns } from "./AnalyzeConceptAskRank.vue?vue&type=template&id=7824d27a&scoped=true&"
import script from "./AnalyzeConceptAskRank.vue?vue&type=script&lang=ts&"
export * from "./AnalyzeConceptAskRank.vue?vue&type=script&lang=ts&"
import style0 from "./AnalyzeConceptAskRank.vue?vue&type=style&index=0&id=7824d27a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7824d27a",
  null
  
)

export default component.exports